import gql from "graphql-tag";

export const providerByTokenQueryFragment = gql`
	fragment providerByTokenQueryFragment on Provider {
		_id
		company_name
		onboardingComplete
	}
`;
